import { Alert, Box, Select, Stack, Text, TextInput } from '@mantine/core';
import { useMemo, useState } from 'react';

import { useGetDeviceTrackerReport } from '../api/getReport';
import { DeviceTrackerHeader } from '../components/DeviceTrackerHeader';
import { LinkReportCard } from '../components/LinkReportCard';

import { ListLoader } from '@/components';
import config from '@/config';

export const DeviceTrackerAdminPage = () => {
  const { data, isLoading, isFetching, refetch, isError, error } = useGetDeviceTrackerReport();
  const [search, setSearch] = useState('');
  const [filterMode, setFilterMode] = useState<string | null>('all');

  const filtered = useMemo(() => {
    if (!data) return [];
    const query = search.trim().toLowerCase();

    return data.filter((item) => {
      if (filterMode === 'visited' && item.totalVisits === 0) return false;
      if (filterMode === 'multi' && !item.multipleDevices) return false;
      if (!query) return true;
      return item.label.toLowerCase().includes(query) || item.slug.toLowerCase().includes(query);
    });
  }, [data, filterMode, search]);

  if (isLoading) {
    return <ListLoader />;
  }

  return (
    <Box p="md" style={{ height: 'calc(100vh - 60px)', overflow: 'auto' }}>
      <Stack gap="lg">
        <DeviceTrackerHeader onRefresh={() => refetch()} isRefreshing={isFetching} />

        {isError && (
          <Alert color="red" title="Не удалось загрузить данные">
            Проверьте, что сервер доступен на{' '}
            <Text component="span" ff="monospace">
              {config.apiUrl}
            </Text>
            . {(error as Error)?.message}
          </Alert>
        )}

        <Stack gap="sm">
          <Stack gap="xs">
            <TextInput
              label="Поиск"
              placeholder="Имя или slug..."
              value={search}
              onChange={(event) => setSearch(event.currentTarget.value)}
            />
            <Select
              label="Фильтр"
              value={filterMode}
              onChange={setFilterMode}
              data={[
                { value: 'all', label: 'Все ссылки' },
                { value: 'visited', label: 'Только с переходами' },
                { value: 'multi', label: 'Несколько устройств' },
              ]}
              allowDeselect={false}
              style={{ maxWidth: 280 }}
            />
          </Stack>

          {!filtered.length ? (
            <Text c="dimmed">Ничего не найдено</Text>
          ) : (
            filtered.map((item) => <LinkReportCard key={item._id} item={item} />)
          )}
        </Stack>
      </Stack>
    </Box>
  );
};
